import {
  BundleIcon,
  BundleRemoveIcon,
  GraduationHat01Icon,
  GraduationHat02RemoveIcon,
  Mail01Icon,
  MailAddIcon,
  MailMinusIcon,
  MessageTextCircle02Icon,
  Pipeline01Icon,
  Send01Icon,
  Tag01RemoveIcon,
  Tag02Icon,
  UserPlus01Icon,
  Users01Icon,
  UsersRemoveIcon,
} from '@systemeio/icons'
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum'
import { ruleIconClassName } from 'modules/automation-rules/constants/automation-rule-icon-class'
import React, { type JSX } from 'react'

export const getActionIcon = (action: AutomationRuleActionsEnum): JSX.Element => {
  switch (action) {
    case AutomationRuleActionsEnum.add_tag:
      return <Tag02Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.remove_tag:
      return <Tag01RemoveIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.create_user:
    case AutomationRuleActionsEnum.create_white_label_user:
      return <UserPlus01Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.enroll_in_course:
      return <GraduationHat01Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.revoke_access_to_course:
      return <GraduationHat02RemoveIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
      return <BundleRemoveIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
      return <BundleIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.send_email:
      return <Mail01Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.send_email_to_specific_address:
      return <Send01Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.subscribe_to_campaign:
      return <MailAddIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.unsubscribe_from_campaign:
      return <MailMinusIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.grant_access_to_community:
    case AutomationRuleActionsEnum.send_webhook:
      return <Users01Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.revoke_access_to_community:
      return <UsersRemoveIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.assign_to_pipeline_stage:
      return <Pipeline01Icon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.send_sms:
      return <MessageTextCircle02Icon className={ruleIconClassName} />
  }
}
